require('frontend-controller/client/run')(
    require('./clientAppConfig'),
    {
        templates:      require.context('./components/', true, /^\.\/(base\/(form\/|error\/|errors\/|master\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tabStrip\/|tooltip\/|focusAbles).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(core\/).*)(?<!\.pdf)\.ejs$/),
        components:     require.context('./components/', true, /^\.\/(base\/(form\/|error\/|errors\/|master\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tabStrip\/|tooltip\/|focusAbles).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(core\/).*)(?<!\.pdf)\.js$/),
        styles:         require.context('./components/', true, /^\.\/(base\/(form\/|error\/|errors\/|master\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tabStrip\/|tooltip\/|focusAbles).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(core\/).*)(?<!\.pdf)\.less$/),
        translations:   require.context('./i18next/', true, /^\.\/.*\.js$/),
    },
    () => {
        // init vendors
        require('gsap/TweenMax')
    }
)
